import React from "react"
import Text from "~/ui/typography"

interface LoginScreenHeaderProps {
  subtitle: string
  title: string
}

export const LoginScreenHeader: React.FC<LoginScreenHeaderProps> = ({ subtitle, title }) => {
  return (
    <>
      <div className="space-y-2">
        <Text as="p" className="text-[#777]" variant="body_light">
          {subtitle}
        </Text>
        <Text as="h2" variant="heading4_medium">
          {title}
        </Text>
      </div>
      <hr className="mb-10 mt-6 border-t border-[#EAEAEA]" style={{ height: "0.5px" }} />
    </>
  )
}
